export default {
  app: {
    languagePopup: {
      title: 'Atualmente está na versão em inglês do {logo}',
      subtitle: 'Deseja mudar para o seu idioma preferido?',
      cta: 'Mudar para {lang}',
    },
  },
};
